import { render, staticRenderFns } from "./Mastodon.vue?vue&type=template&id=1e559c6c"
import script from "./Mastodon.vue?vue&type=script&lang=js"
export * from "./Mastodon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports